import React from 'react';

export default function TestimonialCard({ texto, nombre, servicio }) {
  return (
    <div className="bg-white rounded-2xl p-8 shadow-sm border border-stone-100 hover:shadow-md transition-shadow">
      <p className="text-stone-600 leading-relaxed text-sm mb-6">"{texto}"</p>
      <div>
        <p className="font-medium text-stone-800 text-sm">{nombre}</p>
        <p className="text-teal-600 text-xs mt-0.5">{servicio}</p>
      </div>
    </div>
  );
}